export const banner = {
  loading: "読み込み中",
  alt: {
    purchaseFirst: "初回購入ボーナス",
    purchaseSecond: "2回目購入ボーナス",
    purchaseThird: "3回目購入ボーナス",
    purchaseFourth: "4回目購入ボーナス",
    purchaseFifth: "5回目購入ボーナス",
    dailyBonus: "デイリーボーナス",
    lovense: "Lovense フルコントロール",
    webPayment: "Web決済でお得にポイント購入",
    spuPointBack: "SPUポイントバック",
    reviewReward: "レビュー投稿で50ptもらえる",
    paidy: "Paidyあと払い お支払いは翌月でOK",
    campaignEimi: "深田えいみコラボイベント開催！",
    campaignEimiPointBack: "超ポイント還元祭！消費ポイントの10%還元",
    campaignEimiPointRanking: "ポイント消費 王座決定戦",
    campaignEimiPresent: "深田えいみの豪華景品をGET！",
    campaignEimiLivePart2: "深田えいみ第2弾ライブ配信 8/31(月)20時スタート！",
    missionMakingCall: "ビデオ通話ミッション",
    findTypeGirl: "好みの女の子が見つかりやすい！",
    searchGirls: "検索機能で好みの女の子とマッチ率UP！",
    saveOnPoints: "カード・Apple Payでポイント購入が最大1200ptお得に",
  },
} as const;
